// import styles
import { Icon } from '@sdb/planning-ui';
import {
  sliderMotionAnimation,
  StyledNoteSliderMotionBox,
  StyledNotesSliderIconButton
} from './NoteSlider.styles';

// import types
import {
  MotionCardSliderAnimationProps,
  MotionSliderIndicatorsProps,
  MotionSliderNavButtonProps
} from './NoteSlider.types';

// import utils
import { AnimatePresence, motion } from 'framer-motion';

const MotionNavButton = motion(StyledNotesSliderIconButton);

export const MotionSliderNavButton = ({
  onClick,
  position = 'left',
  iconType,
  offset = 0,
  ariaLabel,
  ...motionProps
}: MotionSliderNavButtonProps) => {
  return (
    <MotionNavButton
      onClick={onClick}
      aria-label={ariaLabel}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{ y: '-50%', [position === 'left' ? 'left' : 'right']: offset }}
      transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      {...motionProps}
    >
      <Icon type={iconType} />
    </MotionNavButton>
  );
};

export const MotionSliderIndicators = ({
  index,
  setPage,
  safePage,
  ...motionProps
}: MotionSliderIndicatorsProps) => {
  return (
    <motion.button
      type="button"
      key={index}
      onClick={() => setPage([index, index > safePage ? 1 : -1])}
      aria-label={`${index + 1}`}
      aria-current={index === safePage ? true : undefined}
      whileHover={{ scale: 1.3 }}
      animate={{
        scale: index === safePage ? 1.2 : 1,
        opacity: index === safePage ? 1 : 0.4
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: 'var(--mui-palette-primary-main)',
        cursor: 'pointer',
        border: 'none',
        padding: 0
      }}
      {...motionProps}
    />
  );
};

export const MotionCardSliderAnimation = ({
  currentId,
  children,
  direction,
  ...motionProps
}: MotionCardSliderAnimationProps) => {
  return (
    <StyledNoteSliderMotionBox>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={currentId}
          custom={direction}
          variants={sliderMotionAnimation}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: 'spring', stiffness: 320, damping: 28 },
            opacity: { duration: 0.18 }
          }}
          style={{
            gridArea: '1 / 1',
            width: '100%'
          }}
          {...motionProps}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </StyledNoteSliderMotionBox>
  );
};
